module.exports = _IndicoCoreSUIR;